(function () {
  'use strict';

  var prefersReducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  ).matches;

  var targets = document.querySelectorAll(
    '.sn-ing-figures__number[data-animate]'
  );
  if (!targets.length) return;

  // Parse a number string like "14", "100%", "0" into:
  // { value: 14, prefix: '', suffix: '' }
  function parseNumber(str) {
    var clean = (str || '').trim();
    var match = clean.match(/^([^0-9]*)([0-9]+)([^0-9]*)$/);
    if (!match) return null;
    return {
      value:  parseInt(match[2], 10),
      prefix: match[1],
      suffix: match[3]
    };
  }

  // Ease-out cubic
  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function animateCounter(el, parsed) {
    var value    = parsed.value;
    var prefix   = parsed.prefix;
    var suffix   = parsed.suffix;
    // Duration scales with magnitude, capped between 800ms and 1600ms
    var duration = Math.min(1600, Math.max(800, value * 14));
    var startTime = null;

    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      var elapsed  = timestamp - startTime;
      var progress = Math.min(elapsed / duration, 1);
      var eased    = easeOutCubic(progress);
      var current  = Math.floor(eased * value);
      el.textContent = prefix + current + suffix;

      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        // Snap to exact final value
        el.textContent = prefix + value + suffix;
      }
    }

    requestAnimationFrame(step);
  }

  // If reduced motion: leave numbers at their rendered values, do nothing
  if (prefersReducedMotion) return;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;

      var el     = entry.target;
      var parsed = parseNumber(el.textContent);

      // Skip if non-numeric or value is 0 (nothing to count to)
      if (!parsed || parsed.value === 0) {
        observer.unobserve(el);
        return;
      }

      // Start from 0 visually
      el.textContent = parsed.prefix + '0' + parsed.suffix;
      animateCounter(el, parsed);
      observer.unobserve(el);
    });
  }, {
    threshold: 0.6  // Trigger when 60% of the stat is visible
  });

  targets.forEach(function (el) {
    observer.observe(el);
  });

})();
